import { createAction, props } from '@ngrx/store';
import { PaymentIntent } from '@stripe/stripe-js';
import { ErrorMessage } from '../error/error-message.model';
import {
	CompletePaymentIntent,
	CouponState,
	MyPremium,
	MyPremiumModuleElement,
	MyPremiumState,
	PaymentConfirmation,
	PremiumDiscountType,
	PremiumModuleElement,
	PremiumModules,
	PremiumSubscription,
	PremiumTokenError
} from './extra.model';

export const loadPremiumModules = createAction(
	'[Premium] loadPremiumModules',
	props<{ forcedCampaigns: string; userId: number }>()
);

export const loadPremiumModulesSuccess = createAction(
	'[Premium] loadPremiumModulesSuccess',
	props<{ premiumModules: PremiumModuleElement[] }>()
);

export const loadPremiumModulesFailure = createAction(
	'[Premium] loadPremiumModulesFailure',
	props<{ error: ErrorMessage }>()
);

export const checkCodiceSconto = createAction(
	'[Premium] checkCodiceSconto',
	props<{ token: string; userId: number }>()
);

export const checkCodiceScontoSuccess = createAction(
	'[Premium] checkCodiceScontoSuccess',
	props<{ codiceScontoCheck: PremiumModuleElement[] }>()
);

export const checkErrorCodiceScontoSuccess = createAction(
	'[Premium] checkErrorCodiceScontoSuccess',
	props<{ codiceScontoCheck: PremiumTokenError }>()
);

export const checkCodiceScontoFailure = createAction(
	'[Premium] checkCodiceScontoFailure',
	props<{ error: ErrorMessage }>()
);

export const clearErrorToken = createAction('[codiceScontoCheck]  clearErrorToken');

// export const setSubscription = createAction(
// 	'[Premium] setSubscription',
// 	props<{ subscription: PremiumSubscription }>()
// );

export const setSubscriptionSuccess = createAction(
	'[Premium] setSubscriptionSuccess',
	props<{ subscriptionSuccess: boolean }>()
);

export const setSubscriptionFailure = createAction(
	'[Premium] setSubscriptionFailure',
	props<{ error: ErrorMessage }>()
);

export const loadUserPremiumAction = createAction(
	'[Premium] loadUserPremium',
	props<{ userId: number }>()
);

export const loadUserPremiumSuccess = createAction(
	'[Premium] loadUserPremiumSuccess',
	props<{ myPremium: MyPremiumState }>()
);

export const loadUserPremiumFailure = createAction(
	'[Premium] loadUserPremiumFailure',
	props<{ error: ErrorMessage }>()
);

export const loadDiscountType = createAction('[Premium] loadDiscountType');

export const loadDiscountTypeSuccess = createAction(
	'[Premium] loadDiscountTypeSuccess',
	props<{ discountType: PremiumDiscountType[] }>()
);

export const loadDiscountTypeFailure = createAction(
	'[Premium] loadDiscountTypeFailure',
	props<{ error: ErrorMessage }>()
);

export const createCoupon = createAction(
	'[Premium] createCoupon',
	props<{ idTipoSconto: number; userId: number }>()
);

export const createCouponSuccess = createAction(
	'[Premium] createCouponSuccess',
	props<{ coupon: CouponState }>()
);

export const createCouponFailure = createAction(
	'[Premium] createCouponFailure',
	props<{ error: ErrorMessage }>()
);

export const updateSubscription = createAction(
	'[Premium] updateSubscription',
	props<{ module: MyPremiumModuleElement, stripeId: string, userId: number }>()
);

export const updateSubscriptionSuccess = createAction(
	'[Premium] updateSubscriptionSuccess',
	props<{ updateSubscriptionSuccess: boolean }>()
);

export const updateSubscriptionFailure = createAction(
	'[Premium] updateSubscriptionFailure',
	props<{ error: ErrorMessage }>()
);

export const intentSubscriptionAction = createAction(
	'[Premium] intentSubscriptionAction',
	props<{ subscription: PremiumSubscription }>()
);

export const intentSubscriptionSuccess = createAction(
	'[Premium] intentSubscriptionSuccess',
	props<{ intentSubscriptionSuccess: CompletePaymentIntent }>()
);

export const intentSubscriptionFailure = createAction(
	'[Premium] intentSubscriptionFailure',
	props<{ error: ErrorMessage }>()
);

export const confirmCardPaymentAction = createAction(
	'[Premium] confirmCardPayment',
	props<{ paymentConfirmation: PaymentConfirmation; currentUrl: string }>()
);

// export const confirmSubscriptionSuccess = createAction(
// 	'[Premium] confirmSubscriptionSuccess',
// 	props<{ paymentConfirmationSuccess: CompletePaymentIntent; currentUrl: string }>()
// );

export const setPaymentStatus = createAction(
	'[Premium] setPaymentStatus',
	props<{ paymentIntentStatus: PaymentIntent, stripeId: string }>()
);

export const confirmSubscriptionSuccess = createAction(
	'[Premium] confirmSubscriptionSuccess',
	props<{ stripeId: string; currentUrl: string }>()
);

export const confirmCardPaymentFailure = createAction(
	'[Premium] confirmCardPaymentFailure',
	props<{ error: ErrorMessage }>()
);
